import { reportExam } from "@/api/modules/community"

type Meta = {
    examCode: string       // 试卷编码
    examRecordCode: string // 用户试卷编码
    // 事件类型由前端定义
    // 页面加载开始和结束       启动环境开始和结束       webview开始打开和页面加载完成
    event: 'workspaceLoading.Start' | 'workspaceLoading.End' | 'workspaceEnv.Start' | 'workspaceEnv.End' | 'workspaceWebview.Start' | 'workspaceWebview.End'
}

export default function useExamReport() {

    async function report(meta: Meta) {
        try {
            const {event,examCode, examRecordCode, ...args } = meta
            reportExam([
                {
                    btype: 'exam',
                    bcode: examCode,
                    trackId: examRecordCode,
                    event: event,
                    meta: {
                        examCode,
                        examRecordCode,
                        ...args
                    },
                    time: new Date().getTime()
                }
            ])
        } catch (error) {

        }
    }

    return {
        report
    }

}